function isFunction(value) {
  return typeof value === "function";
}
function parseFunctionOrValue(value, ...args) {
  return isFunction(value) ? value(...args) : value;
}
export {
  isFunction,
  parseFunctionOrValue
};
//# sourceMappingURL=utils.js.map
